export default "__VITE_ASSET__Dpgw20tb__"